import React, { useState, useEffect } from "react";
import { useRecoilState } from "recoil";
import {
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Collapse,
  Stack,
} from "@mui/material";
import MenuRender from "./MenuRender";
import { rsActiveMenu } from "../../RecoilStates";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { ReactComponent as Users } from "../../images/svg/Users.svg";
import { ReactComponent as BasicInformation } from "../../images/svg/BasicInformation.svg";
import { ReactComponent as ProductsIcon } from "../../images/svg/ProductsIcon.svg";
import { ReactComponent as Communication } from "../../images/svg/Communication.svg";
import { ReactComponent as AllOrder } from "../../images/svg/AllOrder.svg";
import { ReactComponent as ContentManage } from "../../images/svg/ContentManage.svg";
import { ReactComponent as Reports } from "../../images/svg/Reports.svg";
import { ReactComponent as Logestic } from "../../images/svg/Logestic.svg";
import { ReactComponent as Marketing } from "../../images/svg/Marketing.svg";
import { ReactComponent as Commerce } from "../../images/svg/Commerce.svg";
import { ReactComponent as Advertisments } from "../../images/svg/Advertisments.svg";
import { readFromLS, writeToLS } from "../../util/LocalStrogeService";
import { useSnackbar } from "notistack";
import useBreakpoints from "../../hooks/useBreakpoints";

export default function MenuListRenderer(props) {
  const { enqueueSnackbar } = useSnackbar();
  const [model, setModel] = React.useState(props.model);
  const [state, setState] = useState({ icon: undefined });
  const [rowList, setRowList] = useState([]);
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const [open, setOpen] = React.useState(false);
  const [addresPrint, setAddresPrint] = useState(readFromLS("addresPrint"));
  const [factorPrint, setFactorPrint] = useState(readFromLS("factorPrint"));
  const { isSmall } = useBreakpoints();

  useEffect(() => {
    setOpen(
      model.pages.find((element) => element.id == msActiveMenu.id) == undefined
        ? false
        : true
    );
  }, [msActiveMenu]);

  useEffect(() => {}, [open]);

  const handleClick = () => {
    setOpen(!open);
  };
  useEffect(() => {
    setRowList(
      model.pages.map((elem, i) => {
        return <MenuRender model={elem} key={i} isChild />;
      })
    );
  }, []);

  useEffect(() => {
    binding2(model.groupTitle);
  }, []);

  return (
    <Stack>
      <ListItem
        component="a"
        button
        sx={{
          pb: 0,
          px: 0,
        }}
      >
        <ListItemButton
          sx={{
            "&& .Mui-selected, && .Mui-selected:hover": {
              backgroundColor: "#ffffff6b",
            },
            mb: 1,
          }}
          onClick={handleClick}
        >
          <ListItemIcon sx={{ minWidth: "30px" }}>
            {state.icon ? state.icon : ""}
          </ListItemIcon>
          <ListItemText
            primaryTypographyProps={{
              fontSize: 14,
            }}
            primary={model.groupTitle}
          />
          {open ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>
      </ListItem>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List
          aria-labelledby="nested-list-subheader"
          component="div"
          disablePadding
        >
          {rowList}
        </List>
      </Collapse>
    </Stack>
  );

  function binding2(val) {
    switch (val) {
      case "کاربران":
        setState({
          icon: <Users style={{ width: isSmall ? "18px" : "22px" }} />,
        });
        break;
      case "ارتباط با مشتری":
        setState({
          icon: <Communication style={{ width: isSmall ? "18px" : "22px" }} />,
        });
        break;

      case "اطلاعات پایه":
        setState({
          icon: (
            <BasicInformation style={{ width: isSmall ? "18px" : "22px" }} />
          ),
        });
        break;
      case "محصولات":
        setState({
          icon: <ProductsIcon style={{ width: isSmall ? "18px" : "22px" }} />,
        });
        break;
      case "مدیریت محتوا":
        setState({
          icon: <ContentManage style={{ width: isSmall ? "18px" : "22px" }} />,
        });
        break;
      case "سفارشات":
        setState({
          icon: <AllOrder style={{ width: isSmall ? "18px" : "22px" }} />,
        });
        break;
      case "گزارشات":
        setState({
          icon: <Reports style={{ width: isSmall ? "18px" : "22px" }} />,
        });
        break;
      case "لجستیک":
        setState({
          icon: <Logestic style={{ width: isSmall ? "18px" : "22px" }} />,
        });
        break;
      case "مارکتینگ":
        setState({
          icon: <Marketing style={{ width: isSmall ? "18px" : "22px" }} />,
        });
        break;
      case "تبلیغات":
        setState({
          icon: <Advertisments style={{ width: isSmall ? "18px" : "22px" }} />,
        });
        break;
      case "بازرگانی":
        setState({
          icon: <Commerce style={{ width: isSmall ? "18px" : "22px" }} />,
        });
        break;
      default:
        break;
    }
  }
}
